import { render, staticRenderFns } from "./PageParametersForm.vue?vue&type=template&id=254700f3"
import script from "./PageParametersForm.vue?vue&type=script&lang=js"
export * from "./PageParametersForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('254700f3')) {
      api.createRecord('254700f3', component.options)
    } else {
      api.reload('254700f3', component.options)
    }
    module.hot.accept("./PageParametersForm.vue?vue&type=template&id=254700f3", function () {
      api.rerender('254700f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pageParameters/PageParametersForm.vue"
export default component.exports